// extracted by mini-css-extract-plugin
export default {"nextStepContainer":"PaymentInitiated_nextStepContainer__XfBtZ","skeletonLoadingAnimation":"PaymentInitiated_skeletonLoadingAnimation__69M-b"};